// Dialog per conferma ordine (trasformazione in contratto attivo)
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { CheckCircle2, Calendar, AlertCircle } from 'lucide-react';

const OfferOrdineDialog = ({ 
  open, 
  offer, 
  onClose, 
  agents, 
  selectedAgentId, 
  setSelectedAgentId, 
  meseCompetenza, 
  setMeseCompetenza,
  dataFineNoleggio,
  setDataFineNoleggio,
  onConfirm 
}) => {
  if (!offer) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Plus Jakarta Sans' }}>
            Conferma Ordine - Nuovo Contratto
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="p-4 bg-emerald-50 rounded-lg border border-emerald-200">
            <div className="flex items-center gap-2 mb-2">
              <CheckCircle2 className="w-5 h-5 text-emerald-600" />
              <span className="font-semibold text-emerald-800">Offerta Approvata</span>
            </div>
            <p className="font-medium text-slate-800">
              {offer.contact_info?.nome_cognome}
            </p>
            <p className="text-sm text-slate-500">
              {offer.vehicle_info?.marca} {offer.vehicle_info?.modello}
            </p>
            <p className="text-sm text-emerald-600 font-medium mt-1">
              Canone: €{offer.canone_finale?.toLocaleString('it-IT', { minimumFractionDigits: 2 })}/mese • {offer.durata_mesi} mesi
            </p>
          </div>
          
          <div className="p-3 bg-blue-50 rounded-lg border border-blue-200 text-sm text-blue-800">
            <strong>Cosa succede confermando:</strong>
            <ul className="list-disc list-inside mt-1 space-y-1">
              <li>L&apos;offerta diventa un Contratto Attivo</li>
              <li>Il cliente passa da PROSPECT a ACTIVE</li>
              <li>Il contratto viene aggiunto al Portafoglio Clienti</li>
            </ul>
          </div>
          
          <div className="space-y-2">
            <Label>Agente Assegnato</Label>
            <Select value={selectedAgentId} onValueChange={setSelectedAgentId}>
              <SelectTrigger data-testid="agent-select">
                <SelectValue placeholder="Seleziona agente" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value={offer.user_id}>
                  {offer.user_name} (originale)
                </SelectItem>
                {agents.filter(a => a.id !== offer.user_id).map(agent => (
                  <SelectItem key={agent.id} value={agent.id}>
                    {agent.name} ({agent.competenza_provvigioni}%)
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div className="space-y-2">
            <Label>Mese di Competenza Provvigione</Label>
            <Input
              type="month"
              value={meseCompetenza}
              onChange={(e) => setMeseCompetenza(e.target.value)}
              data-testid="mese-competenza-input"
            />
          </div>
          
          {/* Data Fine Noleggio - OBBLIGATORIA */}
          <div className="space-y-2">
            <Label className="flex items-center gap-2">
              <Calendar className="w-4 h-4 text-amber-600" />
              Data Fine Noleggio <span className="text-red-500">*</span>
            </Label>
            <Input
              type="date"
              value={dataFineNoleggio || ''}
              onChange={(e) => setDataFineNoleggio(e.target.value)}
              data-testid="data-fine-noleggio-input"
              className={!dataFineNoleggio ? 'border-amber-400' : ''}
              required
            />
            {!dataFineNoleggio && (
              <p className="text-xs text-amber-600 flex items-center gap-1">
                <AlertCircle className="w-3 h-3" />
                Obbligatoria per generare alert rinnovi
              </p>
            )}
            {dataFineNoleggio && (
              <p className="text-xs text-slate-500">
                Un TO-DO automatico verrà generato 8 mesi prima della scadenza
              </p>
            )}
          </div>
        </div>
        <div className="flex gap-3">
          <Button 
            variant="outline" 
            className="flex-1"
            onClick={() => onClose(false)}
          >
            Annulla
          </Button>
          <Button 
            className="flex-1 bg-emerald-600 hover:bg-emerald-700"
            onClick={onConfirm}
            disabled={!dataFineNoleggio}
            data-testid="confirm-ordine-btn"
          >
            <CheckCircle2 className="w-4 h-4 mr-2" />
            Conferma Ordine
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OfferOrdineDialog;
